import { Feature } from "geojson";

export * from "./permission";
export * from "./user";
export * from "./background-concentration";
export * from "./custom-meteo";
export * from "./case";
export * from "./scenario";
export * from "./grid";
export * from "./results";
export * from "./layer";
export * from "./emission";
export * from "./legend";
export * from "./lez";
export * from "./residential-zone";

/**
 * Generic types
 */
export interface HistoryState {
  action?: "rerenderWMS";
  point?: L.LatLngLiteral; // TODO: this can be done better with a Redux action like pattern?
  drawing?: Feature; // TODO: this can be done better with a Redux action like pattern?
  bulkEdit?: Array<string | number>;
  // download: {
  //   url: string;
  //   visualName: string;
  //   filename?: string;
  // };
}

export interface MapPosition {
  lat: number;
  lng: number;
  zoom: number;
}

export interface APIError {
  key: string;
  message: string;
  arguments: string[];
}

export interface FilterItem<T = string | number> {
  id: T;
  name: string;
}

export interface Language {
  key: string;
  translation: string;
}

export enum ImportStatus {
  NO_FILE = "NO_FILE",
  UPLOADED = "UPLOADED",
  IMPORTING = "IMPORTING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

export interface MinMax {
  min: number;
  max: number;
}

/**
 * Application specific types
 */

export interface Poi {
  id: number;
  name: string;
  point_frontendSrid: string;
}

export interface Region {
  id: number;
  name: string;
  geom_frontendSrid: string;
}

export interface Substance {
  key: string;
  name: string;
}
